import { z } from 'zod';
import { mapRegionsSchema } from './map-region.schema';
import { vehicleGroupsSchema } from './vehicle-group.schema';

export const mapSetSchema = z.object({
  customMapsetId: z.number(),
  customMapsetName: z.string(),
  mapRegions: mapRegionsSchema.nullable(),
  vehicleGroups: vehicleGroupsSchema.nullable(),
  defaultMapset: z.boolean(),
});

export const mapSetsSchema = z.array(mapSetSchema);

export type MapSet = z.infer<typeof mapSetSchema>;
